import globalColors from '@data/variables/global-colors';

function segmentbuilder () {
	const elId = '#app-segment-builder';
	const elClass = '.js-vue-segment-builder';


	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	Vue.component('nominow-create-new-group', {
		props: ["data", "parent"],
		data: function () {
			return {
				name: 'New Group',
				type: 'Continuous'
			}
		},
		template: `
		<div>
			<nominow-input-text v-model="name" label="Group Name" :required="true"></nominow-input-text>
			<br/>
			<div class="mui-textfield">
				<label n-translate>What is the purpose of the group</label>

				<div class="field is-list">
					<div class="control">
						<label class="radio is-fullwidth">
							<input type="radio" name="role" id="role2" value="Continuous" v-model="type" />
							<span class="disc"></span>
							<div class="subject" n-translate>Continuous campaign</div>
						</label>
					</div>

					<div class="control">
						<label class="radio is-fullwidth">
							<input type="radio" name="role" id="role3" value="Single" v-model="type" />
							<span class="disc"></span>
							<div class="subject" n-translate>One time group</div>
						</label>
					</div>
				</div>

			</div>

			<div class="modal-card-foot has-text-right">
				<button class="button is-link has-min-width" v-on:click.prevent="parent.closemodals()">Cancel</button>
				<button class="button is-primary" v-on:click.prevent="data.submit ? data.submit(name, type) : console.log(name, type, 'no submit prop')">Create</button>
			</div>
		</div>
		`

	});


	const app = new Vue({
		el: elId,

		data: {
			search: {
				field: null,
				searchresults: []
			},
			showChartName: 'chartMainKPIs',
			groups: {
				count: null,
				items: [],
				collapsed: [],
				found: [],
				selectedOriginal: null,
				selected: null,
				selectionsCollapsed: [], // multidimensional
				expanded: null,
				expandedSpiderChart: null,
				expandedScatterChart: null,
				expandedParentSelections: null
			},
			globaltags: {
				count: null,
				items: [],
				selected: null
			},
			globalcombinedtags: {},
			currentAction: null,
			actions: [],
			componentmodal: null,
			modal: null,
			error: null,
			filterValueCache: {},
			saved: true,
			totalUserCount: 0
		},
		created: function () {
			toggleLoader(true);
			const self = this;
			window.onpopstate = function (event) {
				console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);
				if (event && event.state && event.state.page == 'group') {
					const item = event.state.item;
					self.groups.selected = self.getSelectedItem(item.group, item.index, item.parent);
					self.groups.selectedOriginal = JSON.stringify(self.groups.selected);
					self.toggleCollapseAllSelections(true);
				} else {
					self.groups.selected = null;
				}
				toggleLoader(false);
			};

			this.fetchData(() => {
				console.log('fetch data');
				// console.log('callback', history.state);
				if (history && history.state && history.state.page == 'group') {
					const item = history.state.item;
					self.groups.selected = self.getSelectedItem(item.group, item.index, item.parent);
					self.groups.selectedOriginal = JSON.stringify(self.groups.selected);
					self.toggleCollapseAllSelections(true);
					// self.toggleCollapseAllSelections(true);
				}
				self.initSearch();
			});
		},
		mounted: function () {
			$(elClass).removeClass('is-mounting');
			window.onbeforeunload = this.checkForUnsavedChanges;
		},
		computed: {
			filterJson: function () {
				if (this.groups.selected != null) {
					return this.getGroupFilter(this.groups.selected);
				}
				return null;
			}
		},
		watch: {
			'groups.selected': {
				handler: function () {
					// execute filter if groups.selected exists
					if (this.groups != null && this.groups.selected != null) {
						const curFilter = JSON.stringify(this.getGroupFilter(this.groups.selected));
						if (this.activeState != curFilter) {
							this.activeState = curFilter;
							this.executeFilter();
						}
					}
					// refresh summary by groups.expanded if groups.selected does not exist
					if (this.groups != null && this.groups.selected == null && this.groups.expanded) {
						const index = this.groups.expanded.index;
						const childIndex = this.groups.expanded.childIndex;
						if (index && !childIndex) {
							const g = this.groups.items[index];
							this.btnExpandGroup(g, index);
						} else if (index && childIndex) {
							const g = this.groups.items[index];
							const c = g.children[childIndex];
							this.btnExpandSubgroup(c, index, g, childIndex);
						}
					}
				},
				deep: true
			},
			'groups.items': {
				handler: function (evt, a) {
					console.log('groups items handler', evt, a);
					this.initSearch();
					// this.resetTableState();
				}
			}
		},
		methods: {
			checkForUnsavedChanges: function (e) {
				if (this.groups.selected) {
					if (!this.saved) {
						return !this.saved;
					}
				}
				return null;
			},
			fetchData: function (callback) {
				const self = this;
				GETCACHEDSESSION('/baas/nominow_insight/filters')
					.then(xhr => {
						self.error = null;
						let globaltags = JSON.parse(xhr.responseText);
						globaltags = globaltags == null ? [] : globaltags;
						self.globaltags.items = globaltags;
						self.globaltags.count = globaltags.length;

						for (let i = 0; i < globaltags.length; i++) {
							const tag = globaltags[i];
							if (tag.CombinedTagField) {
								const combinedTag = {
									tagCode: tag.TagCode,
									tagType: tag.TagType,
									tagName: tag.TagName,
									combinedField: tag.CombinedTagField,
									combinedDescription: tag.CombinedTagDescription,
									items: null
								};
								self.populateFilterValues(combinedTag);
								if (!self.globalcombinedtags[tag.CombinedTagField]) {
									Vue.set(self.globalcombinedtags, tag.CombinedTagField, []);
								}

								Vue.set(self.globalcombinedtags[tag.CombinedTagField], self.globalcombinedtags[tag.CombinedTagField].length, combinedTag);
							}
						}

						console.log('combined', self.globalcombinedtags, JSON.stringify(self.globalcombinedtags));

						GET('/baas/nominow_insight/selections')
							.then(xhr2 => {
								self.error = null;
								let selections = JSON.parse(xhr2.responseText);
								selections = selections == null ? [] : selections;
								self.groups.items = selections;
								self.groups.count = selections.length;
								for (let k = 0; k < selections.length; k++) {
									self.groups.collapsed[k] = true;
								}
								GETCACHEDSESSION('/baas/nominow_management/uiexpansions')
									.then(xhr3 => {
										self.error = null;
										const response = JSON.parse(xhr3.responseText);
										const insight = Array.prototype.find.call(response, p => p.page == 'Insight');
										self.actions = insight.actions;
										$(elClass).removeClass('is-creating');
										if (callback) {
											callback();
										}
										toggleLoader(false);
									})
									.catch(xhr3 => {
										console.log(xhr3, xhr3.responseText);
										const resp = JSON.parse(xhr3.responseText);
										self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
										$(elClass).removeClass('is-creating');
										toggleLoader(false);
									});
							})
							.catch(xhr2 => {
								const resp = JSON.parse(xhr2.responseText);
								self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
								$(elClass).removeClass('is-creating');
								toggleLoader(false);
							});
					})
					.catch(xhr => {
						const resp = JSON.parse(xhr.responseText);
						self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						$(elClass).removeClass('is-creating');
						toggleLoader(false);
					});

				POST('/baas/nominow_insight/executefilter', { selection: [{ filters: [] }] }).then(xhr => {
					const resp = JSON.parse(xhr.responseText);
					self.totalUserCount = resp.Count;
				});
			},
			toggleCollapseAllGroups: function (bool) {
				if (bool == true || bool == false) {
					for (let i = 0; i < this.groups.collapsed.length; i++) {
						Vue.set(this.groups.collapsed, i, bool);
					}
					return;
				}
				console.log('toggling');
				if (this.groups.collapsed.indexOf(false) > -1) {
					for (let i = 0; i < this.groups.collapsed.length; i++) {
						Vue.set(this.groups.collapsed, i, true);
					}
				} else {
					for (let i = 0; i < this.groups.collapsed.length; i++) {
						Vue.set(this.groups.collapsed, i, false);
					}
				}
			},
			toggleCollapseAllSelections: function (reset) {
				if (this.groups.selectionsCollapsed.length == 0 || reset == true) {
					this.groups.selectionsCollapsed = [];
					for (let i = 0; i < this.groups.selected.selections.length; i++) {
						Vue.set(this.groups.selectionsCollapsed, i, []);
						console.log('1', i, JSON.stringify(this.groups.selectionsCollapsed));
						for (let j = 0; j < this.groups.selected.selections[i].filters.length; j++) {
							Vue.set(this.groups.selectionsCollapsed[i], j, false);
							console.log('2', i, j, JSON.stringify(this.groups.selectionsCollapsed));
						}
					}
				}

				if (this.groups.selectionsCollapsed != null && this.groups.selectionsCollapsed.length > 0) {
					const newstate = !this.groups.selectionsCollapsed[0][0];
					for (let i = 0; i < this.groups.selectionsCollapsed.length; i++) {
						for (let j = 0; j < this.groups.selected.selections[i].filters.length; j++) {
							Vue.set(this.groups.selectionsCollapsed[i], j, newstate);
						}
					}
				}
			},
			showManifest: function () {
				const self = this;
				const selections = [];
				toggleLoader(true);
				if (this.groups.expanded.parent != null) {
					for (let i = 0; i < this.groups.expanded.parent.selections.length; i++) {
						selections.push(this.groups.expanded.parent.selections[i]);
					}
					selections.push(this.groups.expanded.selections[0]);
				} else {
					for (let i = 0; i < this.groups.expanded.selections.length; i++) {
						selections.push(this.groups.expanded.selections[i]);
					}
				}
				this.manifestModal(selections);
			},
			selectedManifest: function () {
				const self = this;
				const selections = [];
				toggleLoader(true);
				if (this.groups.selected.parent != null) {
					for (let i = 0; i < this.groups.selected.parent.selections.length; i++) {
						selections.push(this.groups.selected.parent.selections[i]);
					}
					selections.push(this.groups.selected.selections[0]);
				} else {
					for (let i = 0; i < this.groups.selected.selections.length; i++) {
						selections.push(this.groups.selected.selections[i]);
					}
				}
				this.manifestModal(selections);
			},
			manifestModal: function (selections) {
				const self = this;
				const manifest = {
					selection: selections
				};
				POST('/baas/nominow_insight/manifest', manifest).then(xhr => {
					const manRes = JSON.parse(xhr.responseText);

					const createNewGroupModal = {
						id: 'showManifestModal',
						cardtitle: 'Manifest',
						buttoncolor: 'is-hidden',
						buttontitle: 'Create',
						buttoncanceltitle: 'Cancel',
						carddescription: `<pre class="js-copy-on-click">${manRes.Manifest}</pre>`,
						onCancel: function () {
							self.modal = null;
						},
						onSubmit: function () {
							self.modal = null;
						}
					};
					self.modal = createNewGroupModal;
				});
			},
			/* Methods: All groups */
			resetTableState: function () {
				$('.collapse-element.is-collapsed').removeClass('is-collapsed');
				$('.collapse-icon.fa-flip-vertical').removeClass('fa-flip-vertical');
			},
			btnCreateNewGroup: function () {
				const self = this;

				const submitFunction = function (name, type) {
					if (window.isInputValid('.modal-card-body')) {
						self.createNewGroup(name, type);
						self.closemodals();
					}
				};
				this.componentmodal = {
					title: 'Name your group',
					component: 'nominow-create-new-group',
					parent: this,
					data: {
						submit: submitFunction
					}
				}

				return;

				const cancel = function () {
					self.modal = null;
				};

				const submit = function () {
					if (window.isInputValid('.modal-card-body')) {
						self.createNewGroup(self.modal.input.field);
						self.modal = null;
					}
				};

				const createNewGroupModal = {
					id: 'createNewGroupModal',
					cardtitle: 'Name your group',
					buttoncolor: 'is-primary',
					buttontitle: 'Create',
					buttoncanceltitle: 'Cancel',
					input: {
						type: 'text',
						label: 'Group Name',
						placeholder: 'Group Name',
						required: 'Required'
					},
					onCancel: cancel,
					onSubmit: submit
				};
				this.modal = createNewGroupModal;
			},
			createNewGroup: function (name, type) {
				const group = {
					name: name,
					type: type,
					selections: [],
					subGroups: [],
					children: [],
					totalCount: 0
				};
				if (this.groups.items == null) {
					this.groups.items = [];
				}
				this.groups.items.push(group);
				this.selectGroup(group, this.groups.items.length - 1, null);
				this.addSelection(this.groups.selected == null ? 'UNION' : 'INTERSECT');
			},
			btnEditGroup: function (g, i) {
				this.selectGroup(g, i, null);
			},
			btnAddSubgroup: function (g, i) {
				const self = this;

				const cancel = function () {
					self.modal = null;
				};

				const submit = function () {
					if (window.isInputValid('.modal-card-body')) {
						self.createSubgroup(self.modal.input.field, g, i);
						self.modal = null;
					}
				};

				const createNewGroupModal = {
					id: 'createNewGroupModal',
					cardtitle: 'Name your subgroup',
					buttoncolor: 'is-primary',
					buttontitle: 'Create',
					buttoncanceltitle: 'Cancel',
					input: {
						type: 'text',
						label: 'Subgroup Name',
						placeholder: 'Subgroup Name',
						required: 'Required'
					},
					onCancel: cancel,
					onSubmit: submit
				};
				this.modal = createNewGroupModal;
			},
			createSubgroup: function (name, g, i) {
				const group = {
					name: name,
					selections: [],
					subGroups: [],
					children: [],
					totalCount: 0
				};
				this.groups.items[i].children.push(group);
				this.selectGroup(group, this.groups.items[i].children.length - 1, this.groups.items[i]);
				this.addSelection(this.groups.selected == null ? 'UNION' : 'INTERSECT');
			},
			btnDeleteGroup: function (g, i) {
				const self = this;

				let descr = g.children.length > 0 ? '<span>Deleting this group will also delete the following subgroups. Are you sure?</span>' : '<span>Are you sure?</span>';

				if (g.children.length > 0) {
					descr += '<ul class="unordered-list">';
					for (let i = 0; i < g.children.length; i++) {
						descr += '<li>';
						descr += g.children[i].name;
						descr += '</li>';
					}
					descr += '</ul>';
				}

				const deleteGroupModal = {
					id: 'deleteGroupModal',
					cardtitle: 'Delete group',
					carddescription: descr,
					buttoncolor: 'is-danger',
					buttoncancelcolor: 'is-light',
					buttontitle: 'Delete',
					buttoncanceltitle: 'Cancel',
					onCancel: function () {
						self.modal = null;
					},
					onSubmit: function () {
						self.deleteGroup(g, i);
						self.modal = null;
					}
				};
				this.modal = deleteGroupModal;
			},
			deleteGroup: function (g, i) {
				toggleLoader(true);
				const self = this;
				DELETE(`/baas/nominow_insight/deleteselection?selectionGuid=${g.selectionGuid}`)
					.then(xhr => {
						GET('/baas/nominow_insight/selections')
							.then(xhr2 => {
								const resp = JSON.parse(xhr2.responseText);
								self.groups.items = resp == null ? [] : resp;
								self.groups.selected = null;
								toggleLoader(false);
							})
							.catch(xhr2 => {
								const resp = JSON.parse(xhr2.responseText);
								self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
								toggleLoader(false);
							});
					})
					.catch(xhr => {
						const resp = JSON.parse(xhr.responseText);
						self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						toggleLoader(false);
					});
			},
			btnEditSubgroup: function (c, j, g) {
				this.selectGroup(c, j, g);
			},
			btnDeleteSubgroup: function (c, j, g) {
				const self = this;

				const cancel = function () {
					self.modal = null;
				};

				const submit = function () {
					self.deleteSubgroup(c, j, g);
					self.modal = null;
				};

				const deleteSubgroupModal = {
					id: 'deleteSubgroupModal',
					cardtitle: 'Delete subgroup',
					carddescription: 'Please confirm.',
					buttoncolor: 'is-danger',
					buttoncancelcolor: 'is-light',
					buttontitle: 'Confirm',
					buttoncanceltitle: 'Cancel',
					onCancel: cancel,
					onSubmit: submit
				};
				this.modal = deleteSubgroupModal;
			},
			deleteSubgroup: function (c, j, g) {
				toggleLoader(true);
				const self = this;
				DELETE(`/baas/nominow_insight/deletesubselection?selectionGuid=${c.selectionGuid}&parentGuid=${g.selectionGuid}`)
					.then(xhr => {
						GET('/baas/nominow_insight/selections')
							.then(xhr2 => {
								const resp = JSON.parse(xhr2.responseText);
								self.groups.items = resp == null ? [] : resp;
								self.groups.selected = null;
								toggleLoader(false);
							})
							.catch(xhr2 => {
								const resp = JSON.parse(xhr2.responseText);
								self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
								toggleLoader(false);
							});
					})
					.catch(xhr => {
						const resp = JSON.parse(xhr.responseText);
						self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						toggleLoader(false);
					});
			},
			selectGroup: function (g, ix, parent) {
				const self = this;
				this.groups.selected = this.getSelectedItem(g, ix, parent);
				this.groups.selectedOriginal = JSON.stringify(this.groups.selected);
				this.toggleCollapseAllSelections(true);
				history.pushState(
					{
						page: 'group',
						item: {
							group: g,
							index: ix,
							parent: parent
						}
					},
					'Detail - Segment Builder - Nominow',
					'/app/segment-builder/group'
				);
			},
			getSelectedItem: function (g, ix, parent) {
				const self = this;
				console.log(g.type);
				return {
					index: ix,
					selectionGuid: g.selectionGuid,
					name: g.name,
					type: g.type,
					parentId: parent != null ? parent.selectionGuid : null,
					parent: parent,
					totalCount: g.totalCount,
					lastModified: g.lastModified,
					lastCalculated: g.lastCalculated,
					createdDate: g.createdDate,
					chart: null,
					selections:
						g.selections == null
							? []
							: Array.prototype.map.call(g.selections, (f, ix) => ({
								type: f.type,
								currentFilter: {},
								currentTag: {},
								tags: self.globaltags.items,
								count: null,
								filters:
									f.filters == null
										? []
										: Array.prototype.map.call(f.filters, (it, jx) => {
											const tag = Array.prototype.find.call(self.globaltags.items, t => t.TagCode == it.tagCode);
											const fltr = {
												id: `Saved${new Date().getTime()}-${ix}-${jx}`,
												tagCode: it.tagCode,
												type: it.type,
												value: it.value,
												arrayvalue: it.arrayvalue,
												maxvalue: it.maxvalue,
												valueop: it.valueop,
												tagType: tag != null ? tag.TagType : null,
												name: tag != null ? tag.TagName : null,
												combinedTag: tag != null ? tag.CombinedTagField : null,
												combinedTagField: tag != null ? tag.CombinedTagField : null,
												combinedTagFieldDescription: tag != null ? tag.CombinedTagDescription : null,
												combinedValues: it.combinedValues ? it.combinedValues : [],
												useCombinedValues: it.combinedValues && it.combinedValues.length > 0,
												newCombinedTag: null,
												items: []
											};
											self.populateFilterValues(fltr);
											return fltr;
										})
							}))
				};
			},
			addCombinedFilter: function (filter, type) {
				var combinedTag = filter.newCombinedTag;
				filter.combinedValues.push({
					combinedTagField: filter.combinedTagField,
					items: combinedTag != null ? combinedTag.items : [],
					tag: combinedTag,
					tagType: combinedTag != null ? combinedTag.tagType : null,
					name: combinedTag != null ? combinedTag.tagName : null,
					tagCode: combinedTag != null ? combinedTag.tagCode : null,
					type: type,
					value: null,
					arrayvalue: [],
					maxvalue: null,
					valueop: null
				});
				filter.newCombinedTag = null;
			},
			btnExpandGroup: function (g, i) {
				if (g == this.groups.expanded) {
					return;
				}
				this.groups.expanded = this.getSelectedItem(g, i, null);
				this.groups.expanded.parentname = null;
				this.groups.expanded.parentGuid = null;
				this.groups.expandedParentSelections = null;
				this.groups.expandedSpiderChart = null;
				this.groups.expandedScatterChart = null;
				this.loadChart(this.showChartName);
			},
			btnExpandSubgroup: function (c, j, g, i) {
				if (c == this.groups.expanded) {
					return;
				}
				const selectedItem = this.getSelectedItem(c, i, g);
				selectedItem.childIndex = j;
				selectedItem.parentname = g.name;
				selectedItem.parentGuid = g.selectionGuid;
				this.groups.expanded = selectedItem;
				const parentitem = this.getSelectedItem(g, i, null);
				this.groups.expandedParentSelections = parentitem.selections;
				this.groups.expandedSpiderChart = null;
				this.groups.expandedScatterChart = null;
				this.loadChart(this.showChartName);
			},
			loadChart: function (name) {
				const selections = [];
				const self = this;

				if (this.groups.expanded.parent != null) {
					for (let i = 0; i < this.groups.expanded.parent.selections.length; i++) {
						selections.push(this.groups.expanded.parent.selections[i]);
					}
					selections.push(this.groups.expanded.selections[0]);
				} else {
					for (let i = 0; i < this.groups.expanded.selections.length; i++) {
						selections.push(this.groups.expanded.selections[i]);
					}
				}

				const postData = {
					selection: window.cloneObject(selections)
				};
				for (let i = 0; i < postData.selection.length; i++) {
					delete postData.selection[i].tags;
				}
				if (name == 'chartMainKPIs' && self.groups.expandedSpiderChart == null) {
					POST('/baas/nominow_insight/groupspider', postData)
						.then(xhr => {
							const response = JSON.parse(xhr.responseText);
							if (response.ErrorCode != undefined) {
								const errorObject = {
									error: response.Message
								};
								self.groups.expandedSpiderChart = errorObject;
								return;
							}
							if (!response.Names || !response.Average || !response.Max) {

								self.groups.expandedSpiderChart = { message: 'No spider configured' }
								return;
							}
							response.ValueTitle = self.groups.expanded.name;
							self.groups.expandedSpiderChart = response;

						})
						.catch(xhr => {
							const resp = JSON.parse(xhr.responseText);
							self.groups.expandedSpiderChart = { message: resp.Message != '' ? resp.Message : window.timeOutResponseText };
						});
				} else if (name == 'chartTotalvSegment' && self.groups.expandedScatterChart == null) {
					POST('/baas/nominow_insight/groupscatter', postData)
						.then(xhr => {
							const response = JSON.parse(xhr.responseText);
							if (response.ErrorCode != undefined) {
								const errorObject = {
									error: response.Message
								};
								self.groups.expandedScatterChart = errorObject;
								return;
							}
							if (!response.Factors) {

								self.groups.expandedScatterChart = { message: 'No groupscatter configured' }
								return;
							}

							self.groups.expandedScatterChart = response;
						})
						.catch(xhr => {
							const resp = JSON.parse(xhr.responseText);
							self.groups.expandedScatterChart = { message: resp.Message != '' ? resp.Message : window.timeOutResponseText };
						});
				}
			},
			/* /Methods: All groups */
			/* Methods: Expanded group */
			selectAction: function (action, ix) {
				if (action.componentCode != null && action.componentCode != '' && Vue.options.components[action.component] == null) {
					// TODO register components
					$('body').append(`<script id="scriptfor-${action.component}">Vue.component("${action.component}", ${action.componentCode})</script>`);
				}

				this.componentmodal = {
					title: `${action.name} ${this.groups.expanded.parentname != null ? `${this.groups.expanded.parentname} - ` : ''}${this.groups.expanded.name}`,
					component: action.component,
					data: this.groups.expanded
				};
			},
			populateFilterValues: function (filter) {
				const self = this;
				if (filter.tagCode != null && (filter.tagType == 'Multiple-select' || filter.tagType == 'Multiple-select-date')) {
					if (self.filterValueCache[filter.tagCode]) {
						filter.items = self.filterValueCache[filter.tagCode];
					} else {
						GETCACHEDSESSION(`/baas/nominow_insight/filtervalues?TagCode=${filter.tagCode}`)
							.then(xhr => {
								if (xhr.responseText) {
									self.error = null;
									filter.items = JSON.parse(xhr.responseText);
									self.filterValueCache[filter.tagCode] = JSON.parse(xhr.responseText);
								} else {
									window.initToast(`Timeout on filtervalues for ${filter.tagCode}`, 'error');
									filter.items = [];
								}
							})
							.catch(xhr => {
								window.initToast(`Failed to get filtervalues for ${filter.tagCode}${xhr.responseText}`, 'error');
							});
					}
				}
			},
			getGroupFilter: function (g) {
				const fltr = Array.prototype.map.call(g.selections, obj => ({
					type: g.parentId == null ? 'UNION' : 'INTERSECT',
					filters: Array.prototype.map.call(obj.filters, f => ({
						tagCode: f.tagCode,
						value: f.tagType == 'Boolean' ? true : f.value,
						arrayvalue: f.arrayvalue,
						maxvalue: f.maxvalue,
						valueop: f.valueop,
						type: f.type,
						combinedTagField: f.combinedTagField,
						combinedValues:
							f.useCombinedValues && f.combinedValues.length > 0
								? f.combinedValues.map(function (cmf) {
									return {
										combinedTagField: cmf.combinedTagField,
										arrayvalue: cmf.arrayvalue,
										maxvalue: cmf.maxvalue,
										tagCode: cmf.tagCode,
										value: cmf.value,
										valueop: cmf.valueop,
										type: cmf.type,
										enabled: cmf.enabled
									}
								})
								: null
					}))
				}));
				return fltr;
			},
			/* /Methods: Expanded group */
			/* Methods: Selected group */
			btnSave: function () {
				vuelog('SAVE', this.groups.selected)
				if (this.groups.selected.parentId == null) {
					this.saveGroup();
				} else {
					this.saveSubgroup();
				}
			},
			saveGroup: function () {
				toggleLoader(true);
				const self = this;
				POST('/baas/nominow_insight/storeselection', { selection: this.groups.selected }, 30000)
					.then(xhr => {
						self.error = null;
						GET('/baas/nominow_insight/selections')
							.then(xhr2 => {
								self.error = null;
								const resp = JSON.parse(xhr2.responseText);
								self.groups.items = resp == null ? [] : resp;
								history.go(-1);
								self.saved = true;
							})
							.catch(xhr2 => {
								const resp = window.JSONOREMPTY(xhr2.responseText);
								self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
								toggleLoader(false);
							});
					})
					.catch(xhr => {
						const resp = window.JSONOREMPTY(xhr.responseText);
						self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						toggleLoader(false);
					});
			},
			saveSubgroup: function () {
				toggleLoader(true);
				const self = this;
				POST(
					'/baas/nominow_insight/storesubselection',
					{
						parentGuid: this.groups.selected.parentId,
						selection: this.groups.selected
					},
					30000
				)
					.then(xhr => {
						self.error = null;
						GET('/baas/nominow_insight/selections')
							.then(xhr2 => {
								self.error = null;
								const resp = JSON.parse(xhr2.responseText);
								self.groups.items = resp == null ? [] : resp;
								history.go(-1);
								self.saved = true;
							})
							.catch(xhr2 => {
								const resp = window.JSONOREMPTY(xhr2.responseText);
								self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
								toggleLoader(false);
							});
					})
					.catch(xhr => {
						const resp = window.JSONOREMPTY(xhr.responseText);
						self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						toggleLoader(false);
					});
			},
			btnCancel: function () {
				// see onpopstate handler in created above
				self.saved = true;
				history.go(-1);
			},
			btnRecalculate: function () {
				this.executeFilter();
			},
			executeFilter: $.debounce(1000, function () {
				if (this.groups.selected == null) return;
				this.saved = JSON.stringify(this.groups.selected) == this.groups.selectedOriginal;
				$('.js-loader').addClass('is-loading');

				// toggleLoader(true);
				const self = this;
				let ff = [];
				if (this.groups.selected.parentId != null) {
					for (let i = 0; i < this.groups.items.length; i++) {
						const g = this.groups.items[i];
						if (g.selectionGuid == this.groups.selected.parentId) {
							for (let j = 0; j < g.selections.length; j++) {
								ff.push(g.selections[j]);
							}
							break;
						}
					}
					ff.push(this.filterJson[0]);
				} else {
					ff = this.filterJson;
				}
				this.groups.selected.totalCount = '...';
				POST('/baas/nominow_insight/executefilter', { selection: ff }, 30000)
					.then(xhr => {
						self.error = null;
						if (xhr.status == 200) {
							const result = window.JSONOREMPTY(xhr.responseText);
							self.groups.selected.totalCount = result.Count;
							if (self.groups.selected.parentId == null) {
								for (let i = 0; i < result.SubCounts.length; i++) {
									self.groups.selected.selections[i].count = result.SubCounts[i];
								}
							}
						} else {
							window.initToast(`AAAAAA${xhr.responseText}`, 'error');
						}
						$('.js-loader').removeClass('is-loading');
						// toggleLoader(false);
					})
					.catch(xhr => {
						const resp = window.JSONOREMPTY(xhr.responseText);
						if (resp.Message != null) {
							window.initToast(resp.Message, 'error');
						} else {
							console.log('error on execfilter', xhr);
						}
						$('.js-loader').removeClass('is-loading');
						// toggleLoader(false);
					});
			}),
			chosenCombinedValue: function (combined, showFull) {
				combined.tag = Array.prototype.find.call(this.globalcombinedtags[combined.combinedTagField] || [], t => t.tagCode == combined.tagCode);
				const stub = {
					tagType: combined.tag ? combined.tag.tagType : 'todo',
					items: combined.tag ? combined.tag.items : [],
					arrayvalue: combined.arrayvalue,
					valueop: combined.valueop,
					value: combined.value,
					maxvalue: combined.maxvalue,
					name: combined.tag ? combined.tag.tagName : 'todo'
				};
				return this.chosenValue(stub, showFull);
			},
			chosenValue: function (f, showFull) {
				// NOTE: Copied to dashboard!! with slight modifications
				// NOTE: Copied to dashboard!! with slight modifications
				// NOTE: Copied to dashboard!! with slight modifications
				// NOTE: Copied to dashboard!! with slight modifications
				// NOTE: Copied to dashboard!! with slight modifications
				// NOTE: Copied to dashboard!! with slight modifications
				let chosenValue = '';
				if (f == null) {
					chosenValue = 'No values chosen.';
				} else if (f.tagType == 'Multiple-select' || f.tagType == 'Multiple-select-date') {
					if (f.items != null && f.items.length > 0 && f.arrayvalue.length > 0) {
						let result = '';
						for (let i = 0; i < f.arrayvalue.length; i++) {
							const val = Array.prototype.find.call(f.items, it => it.key == f.arrayvalue[i]);
							if (val == null) continue;
							if (i > 0) {
								result += ', ';
							}
							if (i == 3 && showFull != true) {
								result += `...${f.arrayvalue.length} total`;
								break;
							}
							result += val.value;
						}
						chosenValue = result;
					} else {
						chosenValue = 'Select values';
					}
					if (f.tagType == 'Multiple-select-date') {
						let o = f.valueop == null ? 'Select operation' : f.valueop;
						let v = f.value == null ? '...' : f.value;
						let mv = f.maxvalue == null ? '...' : f.maxvalue;
						if (o == 'isnull') {
							v = '';
							o = 'Is Not Set';
						}
						if (o == 'notnull') {
							v = '';
							o = 'Is Set';
						}
						chosenValue += ` ${o} ${v}${o == 'Between' ? ` and ${mv}` : ''}`;
					}
				} else if (f.tagType == 'Boolean') {
					chosenValue = `Has ${f.name} tag`;
				} else if (f.tagType == 'Text') {
					chosenValue = f.value == null || f.valueop == '' ? 'Enter text' : f.value;
				} else if (f.tagType == 'Date') {
					let o = f.valueop == null ? 'Select operation' : f.valueop;
					let v = f.value == null ? '...' : f.value;
					let mv = f.maxvalue == null ? '...' : f.maxvalue;
					if (o == 'isnull') {
						v = '';
						o = 'Is Not Set';
					}
					if (o == 'notnull') {
						v = '';
						o = 'Is Set';
					}
					chosenValue = `${o} ${v}${o == 'Between' ? ` and ${mv}` : ''}`;
				} else if (f.tagType == 'Int') {
					let o = f.valueop == null ? 'Select operation' : f.valueop;
					let v = f.value == null ? '...' : f.value;
					let mv = f.maxvalue == null ? '...' : f.maxvalue;
					if (o == 'isnull') {
						v = '';
						o = 'Is Not Set';
					}
					if (o == 'notnull') {
						v = '';
						o = 'Is Set';
					}
					chosenValue = `${o} ${v}${o == 'Between' ? ` and ${mv}` : ''}`;
				}
				return chosenValue;
			},
			addSelection: function (type) {
				if (this.groups.selected.selections == null) {
					this.groups.selected.selections = [];
				}
				this.groups.selected.selections.push({
					type: type,
					filters: [],
					currentTag: {},
					tags: this.globaltags.items,
					count: null
				});
			},
			addFilter: function (s, filterType, btnIsDisabled, isel) {
				if (btnIsDisabled) {
					return;
				}
				const self = this;
				GETCACHEDSESSION(`/baas/nominow_insight/filtervalues?TagCode=${s.currentTag.TagCode}`)
					.then(xhr => {
						self.error = null;
						const flt = {
							id: `New${new Date().getTime()}`,
							items: JSON.parse(xhr.responseText),
							tagType: s.currentTag.TagType,
							name: s.currentTag.TagName,
							tagCode: s.currentTag.TagCode,
							type: filterType,
							value: null,
							arrayvalue: [],
							maxvalue: null,
							valueop: null,
							combinedTagField: s.currentTag.CombinedTagField,
							combinedTagFieldDescription: s.currentTag.CombinedTagDescription,
							combinedValues: []
						};
						if (!self.groups.selectionsCollapsed[isel]) {
							self.groups.selectionsCollapsed[isel] = [];
						}
						Vue.set(self.groups.selectionsCollapsed[isel], s.filters.length, false);
						s.filters.push(flt);
						s.currentTag = {};
					})
					.catch(xhr => {
						const resp = JSON.parse(xhr.responseText || {});
						self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						s.currentTag = {};
					});
			},
			switchFilterType: function (f) {
				if (f.type == 'include') {
					f.type = 'exclude';
				} else {
					f.type = 'include';
				}
			},

			removeFilter: function (s, ix) {
				const self = this;
				const select = s;
				this.modal = window.deleteConfirmComponent(
					self,
					() => {
						select.filters.splice(ix, 1);
						self.modal = null;
					},
					'Delete filter from selection'
				);
			},
			removeSelection: function (ix) {
				const self = this;
				const index = ix;
				this.modal = window.deleteConfirmComponent(
					self,
					() => {
						self.groups.selected.selections.splice(index, 1);
						self.modal = null;
					},
					'Delete selection'
				);
			},
			removeFromArray: function (arr, ix) {
				if (arr && arr.length > ix) {
					arr.splice(ix, 1);
				}
			},
			initSearch: function () {
				console.log('initSearch');
				this.groups.found = [];
				for (let i = 0; i < this.groups.items.length; i++) {
					if (this.groups.items[i].children.length == 0) {
						Vue.set(this.groups.found, i, true);
					} else {
						Vue.set(this.groups.found, i, []);
						for (let j = 0; j < this.groups.items[i].children.length; j++) {
							Vue.set(this.groups.found[i], j, true);
						}
					}
				}
			},
			doSearch: function () {
				if (this.search.field == null) {
					return;
				}
				this.initSearch();
				this.resetTableState();

				const $sections = $('table.table > tbody');
				const lis = document.querySelectorAll('table.table tbody tr');
				const search = this.search.field.toLowerCase();
				if (!search) {
					return;
				}
				for (let i = 0; i < $sections.length; i++) {
					const $section = $($sections[i]);
					const $parent = $($section.children()[0]);
					const parentText = $($parent.children()[1])
						.text()
						.toLowerCase();
					const $children = $parent.siblings();
					/* If section contains search text, keep it and the children visible. */
					if ($children.length == 0 && parentText.indexOf(search) == -1) {
						Vue.set(this.groups.found, i, false);
					} else {
						/* Else (section does not contain search text), see if children contain search text. */
						/* If child contains search text, keep it and section visible, else hide children and sections */
						let childContainsText = false;
						for (let j = 0; j < $children.length; j++) {
							const $child = $($children[j]);
							const childText = $($child.children()[1])
								.text()
								.toLowerCase();
							if (!search || childText.indexOf(search) > -1) {
								childContainsText = true;
								// $child.removeClass("is-hidden");
							} else {
								Vue.set(this.groups.found[i], j, false);
								// $child.addClass("is-hidden");
							}
						}
						if (childContainsText) {
							// $section.removeClass("is-hidden");
						} else {
							// $section.addClass("is-hidden");
							for (let j = 0; j < $children.length; j++) {
								Vue.set(this.groups.found[i], j, false);
							}
						}
					}
				}
				this.toggleCollapseAllGroups(false);
			},
			btnAddNewBlock: function () {
				this.addSelection('UNION');
			},
			/* /Methods: Selected group */
			closemodals: function () {
				this.modal = null;
				this.componentmodal = null;
			},
			btnExportChart: function (option, chart) {
				if (chart == null || chart.chart == null) {
					return;
				}
				/* See documentation https://api.highcharts.com/class-reference/Highcharts.Chart.html#exportChart */
				const chartOptions = {
					pane: {
						background: {
							backgroundColor: 'transparent'
						}
					},
					xAxis: {
						labels: {
							style: {
								color: globalColors.primary.hue1
							}
						}
					},
					legend: {
						itemStyle: {
							color: globalColors.primary.hue1
						}
					}
				};
				if (option == 'print') {
					chart.chart.print();
				} else if (option == 'png') {
					chart.chart.exportChart({ type: 'image/png' }, chartOptions);
				} else if (option == 'jpeg') {
					chart.chart.exportChart({ type: 'image/jpeg' }, chartOptions);
				} else if (option == 'pdf') {
					chart.chart.exportChart({ type: 'application/pdf' }, chartOptions);
				} else if (option == 'svg') {
					chart.chart.exportChart({ type: 'image/svg+xml' }, chartOptions);
				} else {
					chart.chart.print();
				}
			},
			vueSet: function (a, b, c) {
				return Vue.set(a, b, c);
			},
			vueExtend: function (el1, el2) {
				Vue.util.extend(el1, el2);
				return el1;
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
segmentbuilder();
